function changeGoogleStyles() {
  if ($(".goog-te-menu-frame").contents().find(".goog-te-menu2").length) {
    $(".goog-te-menu-frame").contents().find(".goog-te-menu2").css({
      "max-width": "100%",
      overflow: "scroll",
      "box-sizing": "border-box",
      height: "auto",
    });
  } else {
    setTimeout(changeGoogleStyles, 50);
  }
}

changeGoogleStyles();

function googleTranslateElementInit() {
  new google.translate.TranslateElement(
    {
      pageLanguage: "en",
      layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
    },
    "google_translate_element"
  );
}

var transCount = 0;
$(window).scroll(function () {
  if ($(this).scrollTop() > 10 && transCount < 1) {
    var googleTrans = document.createElement("script");
    googleTrans.type = "text/javascript";
    googleTrans.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(googleTrans);
    transCount = 1;
  }
});
